import * as React from "react";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import FullCVPage from "../pages/full-cv-page";
import MainPage from "../pages/main/main-page";
import { AnimatePresence, motion } from "motion/react";
import InterviewPage from "../pages/interview-page";
import { InterviewGate } from "./Interview-gate";
import CvPrintPage from "../pages/cv-print-page";
import ContactPage from "../pages/contact/contact-page";
import PrivacyPage from "../pages/privacy-page";
import MetrikaTracker from "../analytics/MetrikaTracker";

interface IAppRouterProps {}

const pageVariants = {
  initial: { opacity: 0, y: 8 },
  animate: { opacity: 1, y: 0 },
  exit: { opacity: 0, y: -8 },
};

const AppRouter: React.FunctionComponent<IAppRouterProps> = (props) => {
  const location = useLocation();
  return (
    <div className="relative h-full min-h-0 w-full overflow-hidden">
      <MetrikaTracker />
      <AnimatePresence mode="wait" initial={false}>
        <motion.div
          key={location.pathname}
          variants={pageVariants}
          initial="initial"
          animate="animate"
          exit="exit"
          transition={{ duration: 0.22 }}
          className="w-full h-full min-h-0"
        >
          <Routes location={location}>
            <Route path="/" element={<MainPage />} />
            <Route path="/cv" element={<FullCVPage />} />
            <Route
              path="/interview"
              element={
                <InterviewGate>
                  <InterviewPage />
                </InterviewGate>
              }
            />
            <Route path="/cv/print" element={<CvPrintPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/privacy" element={<PrivacyPage />} />

            {/* 404 */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </motion.div>
      </AnimatePresence>
    </div>
  );
};

export default AppRouter;
